import { createFileRoute, notFound } from "@tanstack/react-router";
import { ComponentShowcase } from "@/components/dev/component-showcase.tsx";

export const Route = createFileRoute("/dev/components")({
  beforeLoad: () => {
    if (false) throw notFound();
  },
  component: ComponentShowcase,
});
